import { API_BASE_URL, adminRequest, getAdminAuthHeaders } from './adminApi';

export const fetchAdminUsers = () => adminRequest('/admin/access/users').then((data) => data.users || []);
export const updateAdminUser = (uid, payload) => adminRequest(`/admin/access/users/${encodeURIComponent(uid)}`, { method: 'PATCH', body: JSON.stringify(payload) }).then((data) => data.user);
export const fetchAdminRoles = () => adminRequest('/admin/access/roles');
export const createAdminRole = (payload) => adminRequest('/admin/access/roles', { method: 'POST', body: JSON.stringify(payload) }).then((data) => data.role);
export const updateAdminRole = (roleId, payload) => adminRequest(`/admin/access/roles/${encodeURIComponent(roleId)}`, { method: 'PATCH', body: JSON.stringify(payload) }).then((data) => data.role);
export const deleteAdminRole = (roleId) => adminRequest(`/admin/access/roles/${encodeURIComponent(roleId)}`, { method: 'DELETE' });
export const fetchAdminSessions = (uid = '') => adminRequest(`/admin/sessions${uid ? `?uid=${encodeURIComponent(uid)}` : ''}`).then((data) => data.sessions || []);
export const revokeAdminSession = (sessionId) => adminRequest(`/admin/sessions/${encodeURIComponent(sessionId)}/revoke`, { method: 'POST', body: JSON.stringify({}) });
export const revokeAllAdminSessions = (uid) => adminRequest(`/admin/sessions/users/${encodeURIComponent(uid)}/revoke`, { method: 'POST', body: JSON.stringify({}) });
export const searchAdminAudit = (params = {}) => adminRequest(`/admin/audit?${new URLSearchParams(params).toString()}`);

export async function exportAdminAudit(params = {}) {
  const headers = await getAdminAuthHeaders();
  const response = await fetch(`${API_BASE_URL}/admin/audit/export?${new URLSearchParams(params).toString()}`, { headers });
  if (!response.ok) throw new Error('Failed to export audit events.');
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'gottea-admin-audit.csv';
  anchor.click();
  URL.revokeObjectURL(url);
}
